import { Nullable } from "@core/domain/types/nullable.type";
import { Undefinable } from "@core/domain/types/undefinable.type";
import { MedicalLeavePeriod } from "@entity/domain/models/employee/contracts/termination/medical-leave-period.model";
import { MedicalLeaveSubtypeEnum } from "@entity/domain/models/employee/medical-leave-subtype.model";
import { TerminationCategoryEnum } from "@entity/domain/models/employee/termination-category.model";
import { TerminationReasonEnum } from "@entity/domain/models/employee/termination-reason.model";
import { DateTime } from "luxon";

export class ContractTermination {
    constructor(
        public readonly id: number,
        public terminationCategory: TerminationCategoryEnum,
        public startDate: DateTime,
        public reason: string,
        public type: Nullable<TerminationReasonEnum>,
        public contractId: number,
        public medicalLeaveSubtype: Nullable<MedicalLeaveSubtypeEnum> = null,
        public cost: Nullable<number> = 0,
        public totalCost: Nullable<number> = 0,
        public endDate: Nullable<DateTime> = null,
        public medicalLeavePeriods: MedicalLeavePeriod[] = [],
    ) {}
}

export class ContractTerminations {
    constructor(
        public readonly contractTerminations: ContractTermination[],
        public readonly count: number,
    ) {}
}

export interface ContractTerminationSearchFilters {
    employee?: Undefinable<number>;
}
